import { StateService } from "@uirouter/angularjs";
import { ICompileService } from "angular";
import { RecordDataSource } from "../../../../../records/grids";
import { ColDef } from "../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../../../records/grids/columns/filters/FilterProvider";
import { LookupFilter } from "../../../../../records/grids/columns/filters/subFilters/LookupFilter";
import { IRowCommandEventArgs } from "../../../../../records/grids/controller";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../records/server/serverUtility";
import { ProgressiveDefinition } from "../../../models/progressiveDefinition";
const colId = Symbol("main.machines.progressives.grid");
export class ProgressivesGridComponentController {
  static $inject = [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$state",
  ];

  private readonly gridDataSource: RecordDataSource;
  private readonly gridSettings: IGridSettings;
  private readonly columns: ColDef[];
  private readonly defaultQuery: IQuery = {};

  constructor(
    serverUtility: ServerUtility,
    gridSettingService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $state: StateService
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/machines/progressives/ProgressiveDefinition"
    );
    this.gridSettings = gridSettingService.getGridSettings(colId);
    this.columns = [
      columnDefinitionService.getCommandColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        name: "view",
        width: 20,
      }),
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getStringColDef({ field: "Name" }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveTypeName",
        header: "Progressive Type",
        filter: new FilterProvider("ProgressiveTypeName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["ProgressiveTypeId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  search,
                  url: "/api/machines/progressives/ProgressiveType",
                }),
            })
          )
          .getGridFilterFactory(),
      }),
    ];
  }

  onItemCommand(args: IRowCommandEventArgs<ProgressiveDefinition>) {
    switch (args.commandName) {
      case "view":
        this.$state.go(".detail.machines", {
          progressiveDefinitionId: args.data.Id,
        });
    }
  }

  /*
  grid-data-source="stateController.gridDataSource"
    grid-settings="stateController.gridSettings"
    columns="stateController.columns"
    default-sort="'Name'"
    default-query="stateController.defaultQuery"
    name-singular="'Progressive Definition'"
    show-add-button="true"
    show-add-button-permission="'machineEdit'"
    show-select-buttons="false"
    on-item-command="stateController.onItemCommand(args)" */
}
